import { IconName } from '@wui/common-library'

import { PLATFORM } from './types'

export type UserAgentView = {
  icon: IconName
  textKey: string
}

const USER_AGENT_VIEWS: (UserAgentView & { match: string })[] = [
  { match: PLATFORM.ASTRA_LINUX, icon: 'astraLinux', textKey: 'chat.astraLinuxDescription' },
  { match: PLATFORM.NODE_JS, icon: 'nodeJS', textKey: 'chat.nodeJSDescription' },
  { match: PLATFORM.LINUX, icon: 'linux', textKey: 'chat.linuxDescription' },
  { match: PLATFORM.MACOS, icon: 'macos', textKey: 'chat.macOSDescription' },
  { match: PLATFORM.IOS, icon: 'macos', textKey: 'chat.iOSDescription' },
  { match: PLATFORM.ANDROID, icon: 'android', textKey: 'chat.androidDescription' },
  { match: PLATFORM.WINDOWS, icon: 'win', textKey: 'chat.windowsDescription' },
  { match: PLATFORM.BOT, icon: 'bot', textKey: 'chat.botDescription' },
]

const WEB_VIEW: UserAgentView = {
  icon: 'web',
  textKey: 'chat.webDescription',
}

export const getUserAgentView = (userAgent?: string | null): UserAgentView | null => {
  if (!userAgent) {
    return null
  }

  const normalized = userAgent.toLocaleLowerCase()
  const view = USER_AGENT_VIEWS.find(({ match }) => normalized === match || normalized.includes(match))

  return view
    ? { icon: view.icon, textKey: view.textKey }
    : WEB_VIEW
}
